import LoadingComponent from "../../app/layout/LoadingComponent";
import { observer } from "mobx-react-lite";
import { Link } from "react-router-dom";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useStore } from "../../app/stores/store";
import { useLocation } from 'react-router-dom';

import Container from "react-bootstrap/Container";
import { Button } from "react-bootstrap";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";

import { Image } from "semantic-ui-react";
import ListConveniosInstitucion from './handlers/ListConveniosInstitucion'

import Footer from "../Footer";

import "./src/pInstitucional.css";
import escudoGuate from "./src/img/escudo_guatemala_fondo.png";
import logoEje from "./src/img/logo-congreso-ejemplo.png";
import ListEstudiantesXConvenio from "./handlers/ListEstudiantesXConvenio";

interface Entidad {
  idEntidad: string;
  entidad: string;
}

let datain: any;

export default observer(function EstudiantesXConvenio() {
  const location = useLocation();
  // const conv = new URLSearchParams(location.pathname).get('conv=');
  // const conv = window.location.pathname.slice(-2)
  const conv = window.location.pathname.split("/")[4];

  const [loading, setLoading] = useState(false);
  const { userStore: { user } } = useStore();
  const [entidad, setEntidad] = useState<Entidad>();
  
  const getDetallePerfil = async () => {
    setLoading(true);

    const perfilAPI = process.env.REACT_APP_API_URL + `/AccountsManager/GetEntityByUser/${user?.id}`;
    const resp = await fetch(perfilAPI);
    datain = await resp.json();
    let enti = datain.entidad;

    setEntidad(enti);
    setLoading(false);
  }; useEffect(() => { getDetallePerfil() }, [ entidad ]);

  return (
    <>

      <Container fluid className="header-institu">
        <Container fluid className="back-head"></Container>

        <Container className="content-head">
          <Row>
            <Col xs={5}>
              <Image src={escudoGuate} />
              <div className="logo-area">
                <Image src={logoEje} />
              </div>
            </Col>
            <Col xs={7}>
              <p>Perfil Institucional -</p>
              <h2>{entidad}</h2>
            </Col>
          </Row>
          <Row className="institu-area-botones">
            <Col className="institu-butt-area" xs={{ span: 3, offset: 7 }}>
            <Link to={'/perfil-institucional/'}>
              <Button disabled variant="btn btn-info">Regresar al Perfil</Button>
            </Link>

            </Col>
          </Row>
        </Container>
      </Container>

      <Container className="content-institu">

        <div className="title-area-institu">
            <h2>Estudiantes por códigos institucionales:</h2>
        </div>

        <div className="bread-institu">
          {/* {myBreadCrumbsConvRaiz(activeC)} */}
        </div>

        <Row>
          <ListEstudiantesXConvenio id={conv} codigoInstitucional={""} />
        </Row>

      </Container>

      <Footer />
    </>
  );

  
})